import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  CompanyRegistrationAddressFormType,
  getCompanyRegistrationAddressSchema,
} from 'modules/client/common/forms/companyRegistrationAddressForm';
import {
  CompanyResidentialAddressFormType,
  companyResidentialAddressSchema,
} from 'modules/client/common/forms/companyResidentialAddressForm';
import {
  CompanyBaseStateRegistrationFormType,
  getCompanyBaseStateRegistrationSchema,
} from 'modules/client/common/forms/companyStateRegistrationForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import {
  LegalClientBranchNameFormType,
  branchNameSchema,
} from './branchNameForm';
import {
  CompanyTaxResidencyFormType,
  companyTaxResidencySchema,
} from './companyTaxResidencyForm';
import { ContactsFormType, getContactsSchema } from './contactsForm';

export interface LegalClientBranchFormType
  extends ContactsFormType,
    LegalClientBranchNameFormType,
    CompanyTaxResidencyFormType,
    CompanyRegistrationAddressFormType,
    CompanyResidentialAddressFormType,
    CompanyBaseStateRegistrationFormType,
    ReasonChangeFormType {}

export const getSchema = (t: TFunc): ObjectSchema<LegalClientBranchFormType> =>
  object()
    .concat(getContactsSchema(t))
    .concat(companyTaxResidencySchema)
    .concat(getCompanyRegistrationAddressSchema())
    .concat(companyResidentialAddressSchema)
    .concat(branchNameSchema)
    .concat(reasonChangeSchema)
    .concat(getCompanyBaseStateRegistrationSchema(t));

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientBranchFormType>();

export type FormErrors = FormErrorsBase<LegalClientBranchFormType>;
